import React, { useEffect, useState } from 'react';

import { useDispatch } from '../../../../chronusStore/helper';
import { leftNavActions } from '../../../../chronusStore/slice/leftNav';

// Components
import SideBarLogo from './components/SideBarLogo';
import SideBarSections from './components/SideBarSections';
import SideBarOptions from './components/SideBarOptions';
import SideBarFooter from './components/SideBarFooter';
import SideBarHorizontalTabs from './components/SideBarHorizontalTabs';
import HorizontalLine from '../../../HorizontalLine';

import ChrPropTypes from '../../../../utils/ChrPropTypes';
import ChronusApi from "../../../../services/ChronusApi";
import SkeletonLoader from '../../../generic/Utils/SkeletonLoader';
import SideBarPromotion from './components/SideBarPromotion';


const App = ({ fetchSectionsUrl, sectionsPayload, shouldDelayLoad, logoData, promotionData, options, footerOptions }) => {

  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    let executed = false;
    const sideBarDataFetcher = () => {
      if(executed) return;

      ChronusApi.getUrlJSON(fetchSectionsUrl, filterPayload(sectionsPayload)).then(({ sections }) => {
        dispatch(leftNavActions.updateInitialData({ sections }))
        setIsLoading(false);
        window.onLoad = AbstractPrograms.fetchSideBar();
      }).catch((error) => console.log("error", error));

      executed = true;
    };

    if(shouldDelayLoad && document.readyState !== 'complete') {
      window.addEventListener("load", sideBarDataFetcher);
      setTimeout(sideBarDataFetcher, 5000); // TimeOutInterval is based on initialize.p95WindowLoadTime. Make sure the interval is same in both places.
    } else sideBarDataFetcher();

    return () => window.removeEventListener("load", sideBarDataFetcher);
  }, []);

  return (
    <React.Fragment>
      <div className="left-nav-app-container">

        <SideBarLogo logoData={logoData} />
        <HorizontalLine additionalClasses={"m-0"}/>
        { promotionData.promotionNeeded && <SideBarPromotion promotionContentUrl={promotionData.contentUrl} /> }
        {isLoading && <SkeletonLoader times={3} />}
        {!isLoading &&
          <>
            <div id="side-menu" className='mt-2'>
              <SideBarSections />
              <SideBarOptions tabs={options} />
              <SideBarFooter  tabs={footerOptions}/>
            </div>
            <SideBarHorizontalTabs />
          </>
        }

      </div>
    </React.Fragment>
  );
};

const filterPayload = (payload) => {
  return Object.entries(payload).reduce((entry,[key,value]) => (value === null ? entry : (entry[key]=value, entry)), {})
}

export default App;

export const LeftNavPropsList = {
  fetchSectionsUrl: ChrPropTypes.string,
  options: ChrPropTypes.object,
  logoData: ChrPropTypes.object,
  promotionData: ChrPropTypes.object,
  sectionsPayload: ChrPropTypes.object,
  shouldDelayLoad: ChrPropTypes.bool,
  footerOptions: ChrPropTypes.object,
}
